import { articleReview } from '@/mocks/articles/review';
import { articleShippingCost } from '@/mocks/articles/shipping-cost';
import { articleCoupon } from '@/mocks/articles/coupon';
import { articleDiscountCode } from '@/mocks/articles/discount-code';
import { articleWarehouse } from '@/mocks/articles/warehouse';
import { articleLegit } from '@/mocks/articles/legit';
import { articleSafety } from '@/mocks/articles/safety';
import { articleDirectory } from '@/mocks/articles/directory';
import { articleCreatorList } from '@/mocks/articles/creator-list';
import { articleSpreadsheetAlternatives } from '@/mocks/articles/alternatives';

export interface ArticleSection {
  title: string;
  paragraphs: string[];
}

export interface ArticleFaq {
  q: string;
  a: string;
}

export interface ArticleLocale {
  title: string;
  description: string;
  tag: string;
  intro: string[];
  sections: ArticleSection[];
  faq: ArticleFaq[];
}

export interface Article {
  slug: string;
  en: ArticleLocale;
  pl: ArticleLocale;
  es: ArticleLocale;
  fr: ArticleLocale;
}

export const articles: Article[] = [
  articleReview,
  articleShippingCost,
  articleCoupon,
  articleDiscountCode,
  articleWarehouse,
  articleLegit,
  articleSafety,
  articleDirectory,
  articleCreatorList,
  articleSpreadsheetAlternatives,
];

export const getArticleBySlug = (slug: string): Article | undefined =>
  articles.find((article) => article.slug === slug);